import React from "react";
import { Layout } from "antd";

import CompetitionsMenu from "../CompetitionsMenu";

const { Sider } = Layout;

const SiderCompetitionsMenu = () => {
  return (
    <Sider
      theme="light"
      width={"256px"}
      style={{
        backgroundColor: "#fff",
        minHeight: "90vh",
        paddingTop: 30,
      }}
    >
      <CompetitionsMenu />
    </Sider>
  );
};

export default SiderCompetitionsMenu;
